import { IPublicationState } from '../../types/reducers/publication';

export const defaultState: IPublicationState = {
  shouldSwitchToSelf: false,
  notEnoughMoney: false,
  unavailableReason: null,
};
